import { blue, pink } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

 
export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#0b42ff',
    },
    secondary: {
      main: '#0b42ff',
    },
    mode: 'light',
  },
  typography: {
    fontFamily: [
      '"DM Sans"',
    ].join(','),
    // fontSize: 16,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        sx: {
          fontSize: "14px",
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        sx: {
          fontSize: "14px",
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        sx: {
          fontSize: "14px",
        }
      }
    },
    
  
  },
 
});